import Play from './Play'

export default Play
